import { useEffect, useState } from "react";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import StatElement, { StatElementProps } from "../StatsSidebar/StatElement";
import SearchIcon from "@mui/icons-material/Search";
import { getLoginData } from "../../services/LocalStorage/loginDataLS";

interface CollectionSidebarProps {
  stats?: Array<StatElementProps>;
  setTextFilter: Function;
  search: Function;
  contentVisiable?: boolean;
}

const CollectionSidebar = ({
  stats,
  setTextFilter,
  search,
  contentVisiable,
}: CollectionSidebarProps) => {
  const [text, setText] = useState<string>("");
  const userData = getLoginData();
  const isPremium = userData?.role === 2;

  const handleSearch = () => {
    search();
  };

  useEffect(() => {
    setTextFilter(text);
  }, [text]);

  return (
    <>
      <Box
        className="shadow-box"
        sx={{
          width: "100%",
          height: "65px",
          borderRadius: "10px",
          backgroundColor: "#fff !important",
          display: { xs: "none", md: "flex" },
          justifyContent: "center",
          alignItems: "center",
          padding: "0px 1rem",
        }}
        aria-label="MyProfile-SearchBox"
      >
        <TextField
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Search Collection"
          size="small"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton type="button" onClick={handleSearch}>
                  <SearchIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& input": {
                padding: "10px !important",
              },
              "& input::placeholder": {
                color: "#3c3c40",
                fontSize: "14px",
                fontWeight: 700,
                marginTop: "2px",
                opacity: 1,
              },
            },
          }}
        />
      </Box>

      {contentVisiable && (
        <Box
          sx={{
            marginTop: { xs: "1rem", md: "1.5rem" },
          }}
        >
          {stats &&
            stats.map((d, index) => (
              <StatElement
                key={index}
                title={d.title}
                currencySymbol={d.currencySymbol}
                value={d.value}
                action={d.action}
                subject={d.subject}
                help={d.help}
                isPremium={isPremium}
              />
            ))}
        </Box>
      )}
    </>
  );
};

export default CollectionSidebar;
